/**
 * Predefined flowsheet templates for AI automation.
 * Each template defines units (with grid positions) and stream connections.
 * col/row are multiplied by COL_SPACING/ROW_SPACING in flowsheet-service.js.
 */

export const FLOWSHEET_TEMPLATES = {
    wastewater: {
        name: 'Wastewater Treatment',
        units: [
            { type: 'Feed',     label: 'Influent Feed',        col: 0, row: 0 },
            { type: 'Screen',   label: 'Bar Screen',           col: 1, row: 0 },
            { type: 'Settler',  label: 'Primary Clarifier',    col: 2, row: 0 },
            { type: 'Reactor',  label: 'Aeration Basin',       col: 3, row: 0 },
            { type: 'Settler',  label: 'Secondary Clarifier',  col: 4, row: 0 },
            { type: 'Filter',   label: 'Effluent Filter',      col: 5, row: 0 },
            { type: 'Thickener',label: 'Sludge Thickener',     col: 4, row: 1 },
            { type: 'Feed',     label: 'Treated Effluent',     col: 6, row: 0 },
            { type: 'Feed',     label: 'Thickened Sludge',     col: 5, row: 1 },
        ],
        connections: [
            [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [4, 6], [5, 7], [6, 8],
        ],
    },

    mineral: {
        name: 'Mineral Processing',
        units: [
            { type: 'Feed',     label: 'Ore Feed',             col: 0, row: 0 },
            { type: 'Crusher',  label: 'Primary Crusher',      col: 1, row: 0 },
            { type: 'Screen',   label: 'Vibrating Screen',     col: 2, row: 0 },
            { type: 'Flotation',label: 'Flotation Cell',       col: 3, row: 0 },
            { type: 'Thickener',label: 'Concentrate Thickener',col: 4, row: 0 },
            { type: 'Filter',   label: 'Pressure Filter',      col: 5, row: 0 },
        ],
        connections: [
            [0, 1], [1, 2], [2, 3], [3, 4], [4, 5],
        ],
    },

    thickening: {
        name: 'Thickening Circuit',
        units: [
            { type: 'Feed',     label: 'Slurry Feed',          col: 0, row: 0 },
            { type: 'Thickener',label: 'Primary Thickener',    col: 1, row: 0 },
            { type: 'Thickener',label: 'Secondary Thickener',  col: 2, row: 0 },
            { type: 'Filter',   label: 'Belt Filter',          col: 3, row: 0 },
            { type: 'Vessel',   label: 'Product Storage',      col: 4, row: 0 },
        ],
        connections: [
            [0, 1], [1, 2], [2, 3], [3, 4],
        ],
    },

    leaching: {
        name: 'Leaching Circuit',
        units: [
            { type: 'Feed',        label: 'Ore Slurry Feed',   col: 0, row: 0 },
            { type: 'Reactor',     label: 'Leach Reactor',     col: 1, row: 0 },
            { type: 'Settler',     label: 'CCD Settler',       col: 2, row: 0 },
            { type: 'Filter',      label: 'Polishing Filter',  col: 3, row: 0 },
            { type: 'Crystallizer',label: 'Crystallizer',      col: 4, row: 0 },
        ],
        connections: [
            [0, 1], [1, 2], [2, 3], [3, 4],
        ],
    },

    distillation: {
        name: 'Distillation System',
        units: [
            { type: 'Feed',              label: 'Process Feed',       col: 0, row: 0 },
            { type: 'FlashDrum',         label: 'Feed Flash Drum',    col: 1, row: 0 },
            { type: 'DistillationColumn',label: 'Distillation Column',col: 2, row: 0 },
            { type: 'HeatExchanger',     label: 'Condenser',          col: 3, row: 0 },
            { type: 'HeatExchanger',     label: 'Reboiler',           col: 3, row: 1 },
        ],
        connections: [
            [0, 1], [1, 2], [2, 3], [2, 4],
        ],
    },
};

const TEMPLATE_KEYWORDS = [
    { keys: ['wastewater', 'waste water', 'sewage', 'wtp', 'effluent'], type: 'wastewater' },
    { keys: ['mineral processing', 'ore processing', 'flotation circuit', 'mineral'], type: 'mineral' },
    { keys: ['thicken'], type: 'thickening' },
    { keys: ['leach', 'solvent extraction', 'sx/ew'], type: 'leaching' },
    { keys: ['distill'], type: 'distillation' },
];

/** Returns the template key if the text matches a known flowsheet, otherwise null. */
export function detectFlowsheetType(text) {
    const lower = text.toLowerCase();
    for (const { keys, type } of TEMPLATE_KEYWORDS) {
        if (keys.some(k => lower.includes(k))) return type;
    }
    return null;
}
